module.exports = __webpack_public_path__ + "img/cover2.0c3f2ba7.jpeg";